<!-- 通用配置-->
<template>
  <div>
    <!-- 折叠公共配置 -->
    <el-collapse accordion>
      <!--      样式模板 暂时支持柱状图 折线图 饼图 柱线混合图 进度条-->
      <el-collapse-item title="样式模板">
        <StyleTemplate :main="main" :prop="main.activeOption"></StyleTemplate>
      </el-collapse-item>
      <!-- 标题设置 -->
      <template v-if="main.validProp('titleList')">
        <el-collapse-item title="标题设置">
          <Title :linkData="linkData" :prop="main.activeOption"></Title>
        </el-collapse-item>
      </template>
      <!-- 轴设置 -->

      <template v-if="main.validProp('barList')">
        <el-collapse-item title="维度轴">
          <x-axis :prop="main.activeOption"></x-axis>
        </el-collapse-item>
        <el-collapse-item title="指标轴">
          <y-axis :main="main" :prop="main.activeOption"></y-axis>
        </el-collapse-item>
        <el-collapse-item title="次指标轴" v-if="main.validProp('subYAxis')">
          <y-axis :main="main" isSub :prop="subYAxis"></y-axis>
        </el-collapse-item>
      </template>
      <template v-if="main.validProp('rightBarList')">
        <el-collapse-item title="副指标轴">
          <right-axis :prop="main.activeOption"></right-axis>
        </el-collapse-item>
      </template>
      <!-- 数值设置 -->
      <template v-if="main.validProp('labelList')">
        <el-collapse-item title="标签">
          <Number :main="main" :prop="main.activeOption"></Number>
        </el-collapse-item>
      </template>
      <!-- 提示语设置  -->
      <template v-if="main.validProp('tipList')">
        <el-collapse-item title="提示语设置">
          <Tip :prop="main.activeOption"></Tip>
        </el-collapse-item>
      </template>
      <!-- 轴距离设置 -->
      <template v-if="main.validProp('positionList')">
        <el-collapse-item title="坐标轴边距设置">
          <Grid :prop="main.activeOption"></Grid>
        </el-collapse-item>
      </template>
      <!-- 图例设置 -->
      <template v-if="main.validProp('legendList')">
        <el-collapse-item title="图例">
          <Legend :prop="main.activeOption"></Legend>
        </el-collapse-item>
      </template>
      <!-- 颜色设置（暂时适配折线图和柱线组合图，后期应取消该配置项）-->
      <template v-if="showCustomColor">
        <el-collapse-item title="自定义配色">
          <Color :prop="main.activeOption"></Color>
        </el-collapse-item>
      </template>
      <template v-if="true">
        <el-collapse-item title="开启刷新">
          <el-form-item label="开启刷新">
            <el-switch v-model="main.activeOption.enableDataRefresh" @change="checkDataRefresh"
                       size="small"></el-switch>
          </el-form-item>
          <el-form-item label="刷新间隔 (ms)" v-if="main.activeOption.enableDataRefresh">
            <el-input-number :min="1000" v-model="main.activeOption.dataRefreshInterval"
                             size="small"></el-input-number>
          </el-form-item>
        </el-collapse-item>
      </template>
    </el-collapse>
  </div>
</template>
<script setup>
import Title from './commonSet/title.vue'
import xAxis from './commonSet/xAxis.vue'
import yAxis from './commonSet/yAxis.vue'
import rightAxis from './commonSet/rightAxis.vue'
import Tip from './commonSet/tip.vue'
import Number from './commonSet/number.vue'
import Legend from './commonSet/legend.vue'
import Grid from './commonSet/grid.vue'
import Color from './commonSet/color.vue'
import StyleTemplate from '@/option/components/commonSet/styleTemplate.vue'
</script>
<script>
import {dicOption, colorOption} from '@/option/config'

export default {
  name: 'maincom',
  inject: ["main"],
  data() {
    return {
      dicOption: dicOption,
      colorOption: colorOption,
      subYAxis: null,
    }
  },
  props: {
    linkData: {}
  },
  methods: {
    checkDataRefresh(val) {
      if (!val) {
        this.main.activeOption.dataRefreshInterval = 0;
      }
    }
  },
  computed: {
    showCustomColor() {
      if (this.main.activeObj) {
        return this.main.validProp('colorList') && this.main.activeObj?.component?.prop != 'line' && this.main.activeObj?.component?.prop != 'mixBar'
      } else {
        return this.main.validProp('colorList')
      }
    },
  },
  created() {
    // 初始化次指标轴，不在复制组件重设字段，直接复用YAxis,初始化无值的情况下，深拷贝主指标内容
    if (!this.subYAxis) {
      this.subYAxis = this.main.activeOption?.subYAxis || this.deepClone(this.main.activeOption)
      this.main.activeOption.subYAxis = this.subYAxis
    }
  }
}
</script>

<style>
</style>